import DisclosureCard from "components/DisclosureCard";

const ThirdCardSx = ({ state }) => {
    return (
        <DisclosureCard
            extra={"w-full p-4 sm:overflow-x-auto"}
            button={() => (
                <div className="relative mb-8 flex items-center justify-between">
                    <div className="flex">
                        <div className=" text-2xl font-bold text-gray-800 dark:text-white">
                            Dati anagrafici
                        </div>
                    </div>
                    <div>
                        <img
                            src="/icon/chevron-down.svg"
                            alt="Dati anagrafici"
                            className="text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                        />
                    </div>
                </div>
            )}
            content={() => (
                <div className="-mx-4 flex flex-wrap">
                    <div className="w-full px-4">
                        <div className="mb-6">
                            <span className="text-sm font-medium text-gray-600">
                                Ragione sociale:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state.name || ""}
                            </span>
                        </div>
                        <div className="flex flex-col gap-2 md:flex-row">
                            <div className="w-full md:w-50p">
                                <span className="text-sm font-medium text-gray-600">
                                    Tel.:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state.phone1 || ""}
                                </span>
                            </div>
                            <div className="w-full md:w-50p">
                                <span className="text-sm font-medium text-gray-600">
                                    Tel. 2:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state.phone2 || ""}
                                </span>
                            </div>
                            <div className="w-full md:w-50p">
                                <span className="text-sm font-medium text-gray-600">
                                    Email:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state.email || ""}
                                </span>
                            </div>
                            <div className="w-full md:w-50p">
                                <span className="text-sm font-medium text-gray-600">
                                    Cell.:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state.mobile || ""}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="my-6 w-full px-4">
                        <hr className="border-lightPrimary" />
                    </div>
                    <div className="w-full px-4">
                        <div className="flex flex-col gap-2 md:flex-row">
                            <div className="w-full md:w-40p">
                                <span className="text-sm font-medium text-gray-600">
                                    Ref. Commerciale:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state.commercial_reference || ""}
                                </span>
                            </div>
                            <div className="w-full md:w-60p">
                                <span className="text-sm font-medium text-gray-600">
                                    Ref. Tecnico:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state.technical_reference || ""}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="my-6 w-full px-4">
                        <hr className="border-lightPrimary" />
                    </div>
                    <div className="w-full px-4">
                        <div className="">
                            <span className="text-sm font-medium text-gray-600">
                                Indirizzo:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state.address || ""}, {state.zip_code || ""}{" "}
                                {state.city || ""} ({state.province || ""}) -{" "}
                                {state.country || ""}
                            </span>
                        </div>
                    </div>
                    <div className="my-6 w-full px-4">
                        <hr className="border-lightPrimary" />
                    </div>
                    <div className="w-full px-4">
                        <div className="">
                            <span className="text-sm font-medium text-gray-600">
                                Descrizione:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state.description || ""}
                            </span>
                        </div>
                    </div>
                </div>
            )}
        />
    );
};

export default ThirdCardSx;
